export enum AgentStatusType {
  AVAILABLE = 'available',
  PAUSE = 'pause',
  PAUSE_POSTCALL = 'pause-postcall',
  IN_CALL = 'in-call',
}
